import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enElementUi from 'element-ui/lib/locale/lang/en'
import thElementUi from 'element-ui/lib/locale/lang/th'

Vue.use(VueI18n)

const messages = {
  en: {
    UNIT_TYPE: {
      PER_PERSON: 'Per Person',
      PER_ROOM: 'Per Room',
      PER_BOOKING: 'Per Booking',
      DISCOUNT: 'Discount',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: 'Net',
      PERCENT: 'Percent (%)',
      NOT_AVAILABLE: 'N/A'
    },
    STATUS: {
      ENABLE: 'Enable',
      DISABLE: 'Disable',
      UNKNOWN: 'N/A'
    },
    ...enElementUi
  },
  th: {
    UNIT_TYPE: {
      PER_PERSON: 'ต่อคน',
      PER_ROOM: 'ต่อห้อง',
      PER_BOOKING: 'ต่อบุ๊คกิ้ง',
      DISCOUNT: 'ส่วนลด',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: 'ราคาสุทธิ',
      PERCENT: 'เปอร์เซ็นต์ (%)',
      NOT_AVAILABLE: 'N/A'
    },
    STATUS: {
      ENABLE: 'ใช้งาน',
      DISABLE: 'ระงับ',
      UNKNOWN: 'N/A'
    },
    ...thElementUi
  }
}

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  },
  th: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  }
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: messages, // set locale messages
  dateTimeFormats: dateTimeFormats // set locale date
})

export default i18n
